<template>
  <div class="consulting-client">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Usuário</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>Cliente</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="client.name"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>Usuário</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="user_name"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dúvida</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Assunto
                      <span class="required-field">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="consulting.subject"
                      :disabled="viewing"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Formule sua Questão
                      <span class="required-field">*</span>
                    </label>
                    <textarea
                      v-model="consulting.question"
                      id
                      cols="30"
                      rows="6"
                      class="form-control"
                      :disabled="viewing"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12"  v-if="formType == 'create'">
                  <div class="form-group d-flex ">
                  <b-form-file
                    ref="newfileinput"
                    placeholder="Escolha um arquivo"
                    drop-placeholder="Arraste o arquivo aqui..."
                    browse-text="Procurar"
                    v-on:change="uploadFile"
                  >
                  </b-form-file>
                  <button
                    class="btn btn-success btn-add-file"
                    v-on:click="addFile()"
                    :disabled="!canAddFile()"
                    v-bind:key="refreshCondition"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label for>Anexos da Pergunta</label>
                    <b-table
                      :fields="fieldsFiles"
                      :items="consulting.files"
                      sticky-header
                    >
                      <template v-slot:cell(id)="data">
                        <div class="d-flex actions-btn">
                          <button
                            class="btn btn-danger"
                            v-on:click="removeFile(data)"
                            v-if="formType == 'create'"
                          >
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                          <a
                            :href="data.item.file_url"
                            v-if="data.item.id"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <button class="btn btn-primary">
                              <i
                                class="fa fa-external-link"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </a>
                        </div>
                      </template>
                    </b-table>
                    <div
                      class="no-data"
                      v-if="!consulting.files || consulting.files.length == 0"
                    >
                      <span>Sem arquivos</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-if="
                  consulting.status == 'Concluído' &&
                  consulting.consulting_answer &&
                  consulting.consulting_answer.id
                "
              >
                <div class="col-12">
                  <div class="title-section">Resposta</div>
                  <div
                    v-html="consulting.consulting_answer.answer"
                    class="text-content"
                  ></div>
                </div>
                <div class="col-12" v-if="consulting.files">
                  <label for>Anexos da Resposta</label>
                  <b-table
                    :fields="fieldsFiles"
                    :items="
                      consulting.consulting_answer.consulting_answer_files
                    "
                    sticky-header
                  >
                    <template v-slot:cell(id)="data">
                      <div class="d-flex actions-btn">
                        <a
                          :href="data.item.file_url"
                          v-if="data.item.id"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button class="btn btn-primary">
                            <i
                              class="fa fa-external-link"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="col-lg-9 col-12">
                  <div class="form-group">
                    <label for>Avaliação da resposta</label>
                    <input
                      type="text"
                      v-model="rating.rating_comment"
                      class="form-control"
                      placeholder="Comentários"
                      :disabled="rated"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-12 ratting-col">
                  <!-- <i class="fa fa-star rating-star" aria-hidden="true"></i> -->
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(1),
                      'fa-star-o empty': !isRatingPoint(1),
                    }"
                    v-on:click="ratingConsulting(1)"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(2),
                      'fa-star-o empty': !isRatingPoint(2),
                    }"
                    v-on:click="ratingConsulting(2)"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(3),
                      'fa-star-o empty': !isRatingPoint(3),
                    }"
                    v-on:click="ratingConsulting(3)"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(4),
                      'fa-star-o empty': !isRatingPoint(4),
                    }"
                    v-on:click="ratingConsulting(4)"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(5),
                      'fa-star-o empty': !isRatingPoint(5),
                    }"
                    v-on:click="ratingConsulting(5)"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <span class="info"
                    >As respostas às dúvidas formuladas são feitas sempre por
                    escrito e disponibilizadas na Área do Cliente em até 30
                    (trinta) horas úteis após a solicitação. As perguntas
                    enviadas após as 12:00 de sexta-feira terão o prazo contado
                    a partir das 08h30 do dia útil subsequente. Questões de
                    maior complexidade ou que contemplem mais de uma dúvida em
                    um único atendimento poderão ser respondidas em prazo
                    superior a 30 horas úteis, situação que será informada via
                    e-mail.</span
                  >
                </div>
              </div>
              <div class="row" v-if="!viewing">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right btn-save"
                    v-on:click="save()"
                  >
                    Enviar dúvida
                  </button>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  viewing &&
                  consulting.consulting_answer &&
                  consulting.consulting_answer.id &&
                  !rated &&
                  consulting.status == 'Concluído'
                "
              >
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right btn-save"
                    v-on:click="rateConsulting()"
                  >
                    Avaliar resposta
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import helper from "@/imports/Helpers";
import moment from "moment";
import consulting_validate from "@/imports/validator/models/consulting";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "consulting-client",
  props: {
    id: Number,
  },
  data() {
    return {
      tempFile: "",
      client: {},
      newFile: {},
      user_name: "",
      consulting: {
        files: [],
      },
      exceed_limit: false,
      refreshCondition: false,
      viewing: false,
      rated: false,
      formType: "create",
      fieldsFiles: [
        { key: "name", label: "Nome", class: "name-cell" },
        { key: "id", label: "Ações", class: "remove-cell" },
      ],
      rating: {
        rating: 0,
        rating_comment: "",
      },
      items: [
        {
          text: "Área do cliente",
          route: "client.dashboard",
        },
        {
          text: "Minhas Dúvidas",
          route: "client.consultings",
        },
        {
          text: "Dúvida",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.user_name = localStorage.getItem("auth.user_name");
    helper.getClientUserPermissions().then((data) => {
      this.client = data;

      if (helper.clientQuantityAccessItem(this.client, "Consultoria") != 0) {
        this.exceed_limit =
          this.client.qtd_consultings >=
          helper.clientQuantityAccessItem(this.client, "Consultoria");
      }
      if (!helper.clientCanAccessItem(this.client, "Consultoria")) {
        this.$router.push({ name: "Home" });
      }
      if (this.id) {
        this.viewing = true;
        this.getDataObject(this.id);
      } else if (this.exceed_limit) {
        Swal.fire({
          title: "Atenção",
          text:
            "O limite de dúvidas contratado foi atingido. A elaboração de orientações está sujeita a suspensão. Por gentileza, entre em contato com nosso departamento comercial.",
          icon: "warning",
        });
      }
    });
  },
  methods: {
    getDataObject: function (id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/consultings/${id}`)
        .then((response) => {
          this.consulting = response.data;
          this.consulting.files = response.data.consulting_files;
          this.rating.rating = this.consulting.rating;
          this.rating.rating_comment = this.consulting.rating_comment;
          if (this.rating.rating != 0 || this.rating.rating_comment) {
            this.rated = true;
          }
          bus.$emit("changeLoading", false);
          this.formType = "edit";
        });
    },
    uploadFile: function (e) {
      const file = e.target.files[0];
      if (
        (!file.type.includes("image/") && !file.type.includes("/pdf")) ||
        file.size > 500000
      ) {
        Swal.fire({
          title:
            "O arquivo não esta nos padrões permitidos, ele não será enviado.",
          icon: "warning",
        });
        this.fileInput = null;
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.tempFile = event.target.result;
          this.newFile.file = file;
          this.refreshCondition = !this.refreshCondition;
        };
        reader.readAsDataURL(file);
      }
    },
    ratingConsulting: function (val) {
      if (!this.rated) {
        this.rating.rating = val;
      }
    },
    isRatingPoint: function (position) {
      return this.rating.rating >= position;
    },
    addFile: function () {
      this.consulting.files.push(this.newFile.file);
      this.newFile = {};
      this.$refs.newfileinput.reset();
    },
    canAddFile: function () {
      return this.newFile.file != null;
    },
    removeFile: function (file) {
      if (file.item.id) {
        let index = this.consulting.files.findIndex((el) => {
          return el.id == file.item.id;
        });
        this.consulting.files.splice(index, 1);
      } else {
        this.consulting.files.splice(file.index, 1);
      }
    },
    rateConsulting: function () {
      if (this.rating.rating == 0 && this.rating.comment == "") {
        Swal.fire({
          title: "É preciso preencher ao menos um dos campos de avaliação.",
          icon: "warning",
        });
      } else {
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/rate_consulting/${this.consulting.id}`,
          this.rating
        );

        promise.then((response) => {
          Swal.fire({
            title: "Dúvida avaliada com sucesso",
            icon: "success",
            allowOutsideClick: false,
            onClose: () => {
              this.$router.push({ name: "client.consultings" });
            },
          });
        });
      }
    },
    getObjToFormData(dataObj) {
      let arrObj = Object.entries(dataObj);
      let formData = new FormData();
      arrObj.forEach((el) => {
        if (Array.isArray(el[1])) {
          el[1].forEach((subEl) => {
            formData.append(el[0] + "[]", subEl);
          });
        } else {
          formData.append(el[0], el[1]);
        }
      });

      return formData;
    },
    save: function () {
      let errors = validator.validate(
        this.consulting,
        consulting_validate.model
      );
      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        this.consulting.user_id = localStorage.getItem("auth.user_id");
        let dataObj = JSON.parse(JSON.stringify(this.consulting));
        dataObj.files = this.consulting.files;
        let data = this.getObjToFormData(dataObj);
        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/consultings`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              enctype: "multipart/form-data",
            },
          }
        );
        promise
          .then((response) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Dúvida enviada com sucesso",
              icon: "success",
              allowOutsideClick: false,
              onClose: () => {
                this.$router.push({ name: "client.consultings" });
              },
            });
          })
          .catch((error) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error",
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach((el) => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.name-cell {
  width: 90%;
}
.remove-cell {
  width: 10%;
}
.consulting-client {
  .text-content {
    border: 1px solid #cfd3d6;
    border-radius: 8px;
    padding: 12px 18px;
    margin-bottom: 18px;
  }
.btn-add-file {
  margin-left: 8px;
}
  .ratting-col {
    padding-top: 35px;
    .ratting-star {
      font-size: 28px;
      margin-right: 5px;
    }
    .ratting-star:hover {
      cursor: pointer;
    }
    .fa-star {
      color: gold;
    }
  }
}
</style>